import { createFederatedCatchAll } from "@anchor/nextjs-mf";

export default createFederatedCatchAll(["anchorFlow"]); //virtual route
